import Entity from "./entity";

export default class groupBuy extends Entity<number> {
  courtId: number | string;
  remark: string = "";
  showOnHome: number;
  court: any;
  creationTime: string;
  creatorUserId: number;
  currentNumber: number;
  description: string;
  endDate: string;
  needNumber: number;
  startDate: string;
  status: number;
  title:string;
  price:number;
  startTime:number;
  teeDate:string;
  sex:number;
  endTime:number;
  priceDiff:number;
  stemNumber:number;
  phoneNumber:string;
  minPerson:number;
  maxPerson:number;
  groupBuyName:string;
  fullName:string;
  services:string;
}
